import { Carousel as CarouselAntd } from "antd"
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";

interface ICarousel {
    imageUrl: string;
    linkUrl: string;
}
interface IPros {
    carouselList?: ICarousel[];
    imgSize?: { x: number, y: number };
    style?: React.CSSProperties;
    indicator?: ReactNode;
    onChange?: (currentSlide: number) => void;
}

const CustomCarousel = ({ carouselList, imgSize, style, indicator, onChange }: IPros) => {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const handleChange = (currentSlide: number) => {
        setCurrentSlide(currentSlide);
        if (onChange) onChange(currentSlide);
    };

    return <>
        {carouselList && carouselList?.length > 0 && <>
            <CarouselAntd draggable afterChange={handleChange} autoplay dots={false} >
                {carouselList?.map((carouse, idx) => <div key={idx}>
                    <div style={{ width: '100%', backgroundImage: `url(${carouse.imageUrl})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', paddingBottom: imgSize ? `${(imgSize.y / imgSize.x) * 100}%` : `${(1.6 / 1) * 100}%`, ...style }} onClick={() => navigate(carouse.linkUrl)} />
                </div>)}
            </CarouselAntd>
            {carouselList && carouselList?.length > 1 &&
                indicator
                ? indicator
                : <div style={{ width: '100%', display: 'flex' }}>
                    {carouselList?.map((_carouse, index: number) => <div key={index} style={{ width: `calc(100% / ${carouselList?.length})`, backgroundColor: currentSlide >= index ? 'black' : '#E9E9E9', height: '2px' }} />)}
                </div>}
        </>}
    </>
}
export { CustomCarousel }